import { render, staticRenderFns } from "./SendProposalModal.vue?vue&type=template&id=63343e07"
import script from "./sendProposalModal.ts?vue&type=script&lang=ts&external"
export * from "./sendProposalModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports